import React, { useState, useRef, useEffect } from 'react';
import './NewsBanner.css';
import myPng from '../../FlyerData/Flyer.png'; // Adjust the path to your PNG file

const NewsBanner = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [scale, setScale] = useState(1);
  const modalImageRef = useRef();

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden'; // Disable page scroll
    } else {
      document.body.style.overflow = 'auto'; // Enable page scroll
    }
    return () => {
      document.body.style.overflow = 'auto'; // Ensure page scroll is enabled when component unmounts
    };
  }, [isModalOpen]);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setScale(1); // Reset scale when closing modal
  };

  const handleWheel = (e) => {
    e.preventDefault();

    setScale((prevScale) => {
      let newScale = prevScale + (e.deltaY < 0 ? 0.2 : -0.2); // Increase increment/decrement value to make zooming faster
      if (newScale < 1) newScale = 1; // Prevent scaling smaller than original size
      return newScale;
    });
  };

  return (
    <div>
      <div className="news-banner">
        <span>Infos zum Kulturwochenende 2024!</span>
        <button onClick={openModal}>Mehr Infos</button>
      </div>

      {isModalOpen && (
        <div className="modal" onWheel={handleWheel}>
          <div className="modal-content">
            <span className="close" onClick={closeModal}>&times;</span>
            <img
              src={myPng}
              alt="Modal Content"
              ref={modalImageRef}
              style={{ transform: `scale(${scale})` }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default NewsBanner;
